var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotGreat(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1525_2700)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.75 13C24.75 19.7655 19.2655 25.25 12.5 25.25C5.73451 25.25 0.25 19.7655 0.25 13C0.25 6.23451 5.73451 0.75 12.5 0.75C19.2655 0.75 24.75 6.23451 24.75 13Z",
    fill: "#FBB47E",
    stroke: "#D9925C",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25 13C25 19.9062 19.4023 25.5 12.5 25.5C8.57031 25.5 5.0625 23.6875 2.76953 20.8477C4.91406 22.582 7.64453 23.6172 10.6172 23.6172C17.5195 23.6172 23.1172 18.0234 23.1172 11.1172C23.1172 8.14453 22.082 5.41406 20.3477 3.26953C23.1836 5.5625 25 9.07031 25 13Z",
    fill: "#D9925C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2328 19.2895C16.2328 19.6543 15.9414 19.9402 15.582 19.9402H9.42031C9.06094 19.9402 8.76953 19.6535 8.76953 19.2895C8.76953 18.9301 9.06094 18.6387 9.42031 18.6387H15.582C15.9406 18.6387 16.2328 18.9301 16.2328 19.2895Z",
    fill: "#3E4347"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.45971 13.2776C5.76518 13.0979 6.66909 14.0666 8.08862 14.1198C9.55815 14.1744 10.4121 13.0979 10.7175 13.2776C11.098 13.408 10.5792 15.8924 8.08862 15.9018C5.59877 15.8924 5.07924 13.408 5.45971 13.2776Z",
    fill: "#3E4347"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.87358 12.1853C4.58999 12.14 4.39624 11.8728 4.44233 11.5884C4.48842 11.3049 4.75092 11.1103 5.03921 11.1572C7.96733 11.6275 8.85717 9.53611 8.86577 9.51501C8.97358 9.24861 9.27671 9.12048 9.54467 9.22907C9.81108 9.33767 9.93921 9.64157 9.83061 9.90798C9.24311 11.347 7.3978 12.5908 4.87358 12.1853Z",
    fill: "#D9925C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5399 13.2776C19.2344 13.0979 18.3305 14.0666 16.911 14.1198C15.4414 14.1744 14.5875 13.0979 14.282 13.2776C13.9016 13.408 14.4203 15.8924 16.911 15.9018C19.4008 15.8924 19.9203 13.408 19.5399 13.2776Z",
    fill: "#3E4347"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1695 9.90714C15.0609 9.64074 15.189 9.33683 15.4554 9.22824C15.7211 9.11964 16.0242 9.24699 16.1336 9.51183C16.1726 9.60558 17.0672 11.622 19.9609 11.1571C20.2476 11.1103 20.5125 11.3048 20.5578 11.5884C20.6031 11.8728 20.4101 12.14 20.1265 12.1853C17.6203 12.5884 15.7617 11.3595 15.1695 9.90714Z",
    fill: "#D9925C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1525_2700"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotGreat);
export default __webpack_public_path__ + "static/media/not_great.b51c3569d6af71626e2dbb46926c78f4.svg";
export { ForwardRef as ReactComponent };